export default (word, count, prefix = "s") =>
  count > 1 ? `${word}${prefix}` : word
